import React from 'react';
import { Head } from '@inertiajs/react';
import DashboardLayout from '../components/DashboardLayout';

interface UserHomeProps {
  user: {
    id: number;
    name?: string;
    username?: string;
    email: string;
    role: 'user' | 'admin' | 'manager';
  };
}

export default function UserHome({ user }: UserHomeProps) {
  const displayName = user?.name || user?.username || user?.email?.split('@')[0] || 'User';

  return (
    <DashboardLayout>
      <Head title="Home" />
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6">
        <h1 className="text-4xl font-bold tracking-tight">
          Welcome{displayName ? `, ${displayName}` : ''}!
        </h1>
        <p className="text-lg text-muted-foreground max-w-md">
          This is your personalized home page. You can manage your profile and settings using the navigation menu.
        </p>
      </div>
    </DashboardLayout>
  );
}
